<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'full' | 'icon' | 'wordmark'
    theme?: 'light' | 'dark'
  }>(),
  {
    variant: 'full',
    theme: 'light',
  }
)
</script>

<template>
  <div class="flex items-center gap-2">
    <!-- Icon: signal wave emerging from noise -->
    <svg
      v-if="variant === 'full' || variant === 'icon'"
      class="shrink-0"
      :class="variant === 'icon' ? 'w-8 h-8' : 'w-7 h-7'"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <!-- Noise (background static dots) -->
      <circle cx="4" cy="8" r="1" class="fill-slate-300 dark:fill-slate-600" opacity="0.5" />
      <circle cx="7" cy="14" r="0.8" class="fill-slate-300 dark:fill-slate-600" opacity="0.4" />
      <circle cx="3" cy="20" r="1.2" class="fill-slate-300 dark:fill-slate-600" opacity="0.3" />
      <circle cx="8" cy="24" r="0.7" class="fill-slate-300 dark:fill-slate-600" opacity="0.4" />
      <circle cx="5" cy="28" r="0.9" class="fill-slate-300 dark:fill-slate-600" opacity="0.3" />
      <!-- Signal wave (clean, emerging) -->
      <path
        d="M10 22 L14 12 L18 20 L22 8 L26 16 L30 6"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="stroke-primary"
        fill="none"
      />
      <!-- Beacon dot -->
      <circle cx="30" cy="6" r="2" class="fill-primary" />
      <circle cx="30" cy="6" r="4" class="fill-primary" opacity="0.2" />
    </svg>

    <!-- Wordmark -->
    <span
      v-if="variant === 'full' || variant === 'wordmark'"
      class="text-lg font-bold tracking-tight whitespace-nowrap"
      :class="[
        theme === 'dark' ? 'text-white' : 'text-text dark:text-dark-text',
      ]"
    >
      Signal<span class="text-primary">Before</span>Noise
    </span>
  </div>
</template>
